import dayjs from "dayjs";

// How much of the past each mode opens with. Only a starting point: the date
// picker owns the range from then on. These pages used to recompute the start
// from the end on every render instead, which silently threw away any range
// picked by hand.
const DAYS_BACK = { minute: 0, epg: 0, hour: 1, day: 7, week: 30, month: 60 };

export function defaultStartFor(mode, endKey) {
  const end = dayjs(endKey, "YYYY-MM-DD");
  return end.subtract(DAYS_BACK[mode] ?? 0, "day").format("YYYY-MM-DD");
}

// In these modes the toolbar shows a single-day picker, which reports only a
// start date — the end has to follow it.
export function isSingleDayMode(mode) {
  return mode === "minute" || mode === "epg" || mode === "ttv";
}

export function todayKey() {
  return dayjs().format("YYYY-MM-DD");
}
